import { render, staticRenderFns } from "./signin-oidc.vue?vue&type=template&id=bb05d172"
import script from "./signin-oidc.vue?vue&type=script&lang=ts"
export * from "./signin-oidc.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports